import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import DashboardCumulativeData from "../model/DashboardCumulativeData";

export default class DashboardCumulativeDataMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {RevisableLanguagePack} languagePack 
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack, mediatorManager) {
        super(target, dispatcher, layoutManager, clickEaterFactory);
        this._mediatorManager = mediatorManager;
        this._languagePack = languagePack;
        this._activeTween = null;
    }

    initialize() {
        super.initialize();
    }

    destroy() {
        super.destroy();
    }

    show() {
        createjs.Tween.get(this._target)
            .to({
                alpha: 1,
            }, 450, createjs.Ease.sineOut);
    }

    hide() {
        createjs.Tween.removeTweens(this._target);
        this._target.alpha = 0;
    }

    /** @param {DashboardCumulativeData} dashboardCumulativeData*/
    setData(dashboardCumulativeData) {
        this._target.annotationTitleTextField.text = dashboardCumulativeData.description;
        this._target.yourOutcomeTextField.text = this._languagePack.getText(`dashboard.cumulativeData.yourOutcome`);
        this._target.bestPossibleOutcomeTextField.text = this._languagePack.getText(`dashboard.cumulativeData.bestOutcome`);
        this._target.worstPossibleOutcomeTextfield.text = this._languagePack.getText(`dashboard.cumulativeData.worstOutcome`);
        this._target.yourOutcomeNumberTextfield.text = dashboardCumulativeData.number;
        this._target.bestPossibleOutcomeNumberTextField.text = dashboardCumulativeData.best;
        this._target.worstPossibleOutcomeNumberTextField.text = dashboardCumulativeData.worst;
    }
}